import "@reach/dialog/styles.css";

import { DialogContent, DialogOverlay } from "@reach/dialog";
import React, { useContext } from "react";

import Button from "./button";
import { ModalContext } from "./modal-context";
import { motion } from "framer-motion";
import styled from "styled-components";
import useKeypress from "./hooks/use-key-press";

const DownloadModal = () => {
    const [showModal, setShowModal] = useContext(ModalContext);
    // const open = () => setShowModal(true);
    const close = () => setShowModal(false);
    useKeypress('Escape', close);

    return (
        <DialogOverlay
            style={{ background: "hsla(0, 0%, 0%, 0.9)" }}
            isOpen={showModal}
            onDismiss={close}
        >
            <StyledDialogContent>
                <CloseButton 
                    onClick={close}
                    whileHover={{fill: '#fff', scale: 1.2, color: "#fff", transition: {type: "spring", stiffness: 700, damping: 30}}}
                    whileTap={{scale: 1.02}}    
                >
                    <CloseIcon/>
                </CloseButton>
                <Container>
                    <div>
                        <VectorQr viewBox="0 0 86 86" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M24.08 12.04v12.04H0V0h24.08v12.04zm17.2-10.32v1.72h3.44V0h3.44v6.88h3.44v3.44h3.44V0h3.44v13.76H51.6v3.44H41.28v-3.44h-3.44v10.32H34.4v3.44h3.44v6.88H51.6v-3.44H41.28V20.64h3.44v6.88h6.88v-3.44h-3.44v-3.44h3.44v3.44h3.44V17.2h3.44v10.32H51.6v3.44h3.44v3.44h3.44v-3.44h3.44v3.44h3.44v-3.44h3.44v-3.44h6.88v3.44h6.88v3.44H86v10.32h-3.44v3.44H86v6.88h-3.44V51.6h-3.44v6.88h-3.44v-3.44h-3.44v17.2h-6.88v3.44H51.6v3.44h-6.88V86h-3.44v-3.44h-3.44V86H34.4v-3.44h-3.44V86h-3.44v-6.88h3.44V68.8h-3.44V58.48h-6.88v-3.44H17.2V51.6h-3.44v3.44h-3.44v3.44H6.88V51.6h3.44v-3.44h6.88v-3.44h3.44v-3.44H17.2V27.52h10.32v3.44h3.44v-6.88h-3.44v-3.44h3.44V17.2h-3.44v-6.88h3.44V6.88h6.88V3.44h-6.88V0h10.32v1.72zM86 12.04v12.04H61.92V0H86v12.04zm-82.56 0v8.6h17.2V3.44H3.44v8.6zm61.92 0v8.6h17.2V3.44h-17.2v8.6zm-48.16 0v5.16H6.88V6.88H17.2v5.16zm24.08-1.72v3.44h3.44v-3.44h3.44v3.44h3.44v-3.44h-3.44V6.88h-6.88v3.44zm37.84 1.72v5.16H68.8V6.88h10.32v5.16zm-48.16 1.72v3.44h3.44v-6.88h-3.44v3.44zm0 8.6v1.72h3.44v-3.44h-3.44v1.72zM6.88 29.24v1.72h6.88v3.44H6.88v-3.44H0v-3.44h6.88v1.72zm13.76 3.44v1.72h3.44v3.44h-3.44v3.44h3.44v-3.44h3.44v6.88h3.44v-3.44h3.44v-3.44h3.44V34.4H34.4v-3.44h-3.44v3.44h3.44v3.44h-6.88v-6.88h-6.88v1.72zm-17.2 3.44v1.72h3.44v3.44h6.88v3.44H3.44v13.76H0v-17.2h3.44v-3.44H0V34.4h3.44v1.72zm55.04 0v1.72h-3.44v3.44h3.44v3.44h3.44v3.44h-6.88v6.88H51.6V41.28h-3.44v-3.44h-6.88v3.44h-3.44V51.6H34.4v-3.44h-6.88v3.44h-6.88v-3.44h3.44v-3.44h-3.44v3.44H17.2v3.44h3.44v3.44h10.32V51.6h3.44v6.88h-3.44v6.88h3.44v-6.88h3.44v6.88h3.44v3.44h6.88v-3.44h3.44v3.44h3.44V55.04h6.88v-6.88h3.44v-3.44h-3.44V34.4h-3.44v1.72zm10.32 0v1.72h-3.44v3.44h3.44v6.88h6.88v3.44h3.44v-6.88h3.44v-6.88h-3.44V34.4h-3.44v6.88h-3.44V34.4H68.8v1.72zM44.72 46.44v1.72h3.44v3.44h-3.44v6.88h-3.44V51.6h3.44v-3.44h-3.44v-3.44h3.44v1.72zm24.08 6.88v1.72h3.44V51.6H68.8v1.72zm-17.2 3.44v1.72h-3.44v-3.44h3.44v1.72zm6.88 6.88v5.16H68.8V58.48H58.48v5.16zm-34.4 10.32V86H0V61.92h24.08v12.04zm20.64-10.32v1.72h-3.44v-3.44h3.44v1.72zm20.64 0v1.72h-3.44v-3.44h3.44v1.72zM86 65.36v3.44h-3.44v-6.88H86v3.44zm-82.56 8.6v8.6h17.2v-17.2H3.44v8.6zm13.76 0v5.16H6.88V68.8H17.2v5.16zm61.92-3.44v1.72H86V86h-3.44V75.68h-3.44v3.44h-6.88v3.44h3.44V86h-3.44v-3.44h-6.88V86H55.04v-6.88h6.88v3.44h3.44v-3.44h6.88v-3.44h6.88v-3.44h-3.44V68.8h3.44v1.72zM34.4 73.96v1.72h3.44v3.44H34.4v3.44h3.44v-3.44h6.88v-3.44h-3.44v-3.44H34.4v1.72z"
                                fill="#fff"
                            />
                        </VectorQr>
                    </div>
                    <Meta>
                        <Text>Scan with your camera to download</Text>
                        <Button href="https://apps.apple.com/app/apple-store/id1447330651?pt=2056961&ct=web&mt=8" />
                    </Meta>
                </Container>
            </StyledDialogContent>
        </DialogOverlay>
    )
}

const StyledDialogContent = styled(DialogContent)`
    padding: 1rem 2rem;
    background-color: #051426;
    color: #FFFFFF;
    border: 2px solid #11315F;
    border-radius: 10px;
    width: 20rem;
    text-align: right;
`

const Text = styled.div`
    padding-bottom: 2rem;
    font-size: 1rem;
    font-weight: 600;
`
const Meta = styled.div`
    margin: 0 auto;
    text-align: center;
    padding-top: 1rem;
`
const Container = styled.div`
    padding: 1rem;
    padding-top: 2rem;
    display: flex;
    flex-direction: column;
`
const VectorQr = styled.svg`
    width: 100%;
    height: 100%;
`

const CloseButton = styled(motion.button)`
    margin-right: -0.95rem;
    color: #6AA7F8;
    border: none;
    background: transparent;
    border-radius: 23px;
    cursor: pointer;
    &:focus {
        outline: none;
    }
    &:focus-visible {
        box-shadow: 0 0 0 2pt ${props => props.theme.color.textSecondary};
    }
`
const StyledCloseIcon = styled.svg`
    height: 32px;
    width: 32px;
`
const CloseIcon = () => {
    return (
        <StyledCloseIcon width="46" height="46" viewBox="0 0 46 46" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M23 0C10.2974 0 0 10.2975 0 23C0 35.7025 10.2974 46 23 46C35.7026 46 46 35.7025 46 23C46 10.2975 35.7026 0 23 0ZM13.8066 31.9852C13.416 31.5947 13.416 30.9615 13.8066 30.571L21.2321 23.1454L14.1619 16.0752C13.7714 15.6847 13.7714 15.0515 14.1619 14.661C14.5524 14.2705 15.1855 14.2705 15.5761 14.661L22.6464 21.7312L30.07 14.3075C30.4606 13.917 31.0937 13.917 31.4843 14.3075C31.8748 14.6981 31.8748 15.3312 31.4843 15.7218L24.0605 23.1454L31.8395 30.9244C32.2301 31.315 32.2301 31.9481 31.8395 32.3387C31.449 32.7292 30.8159 32.7292 30.4254 32.3387L22.6464 24.5597L15.2208 31.9852C14.8303 32.3757 14.1971 32.3757 13.8066 31.9852Z" fill="currentColor"/>
        </StyledCloseIcon>
    )
}


export default DownloadModal
